module.exports = __webpack_public_path__ + "static/media/IMG_1861.02388616.JPG";